<template>
  <div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="80px" label-position="right" class="search-form">
        <el-form-item label="账号">
          <el-input v-model="filters.empno" clearable></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="filters.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="角色名称">
          <el-select multiple v-model="filters.jurisdictionId" @input="testSX" clearable>
            <el-option v-for="(item) in roles" :key="item.id" :label="item.jurisdictionName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="filters.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="add"><i class="fa fa-plus"></i>添加用户</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="empId" label="用户编号"></el-table-column>
        <el-table-column prop="empno" label="账号"></el-table-column>
        <el-table-column prop="userName" label="名称"></el-table-column>
        <el-table-column prop="jurisdictionName" label="角色名称"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button-group>
              <el-button style="margin-right: 10px;" @click="edit(scope.$index, scope.row)" type="primary" size="small">编辑</el-button>
              <!-- <el-button @click="del(scope.$index, scope.row)" type="danger" size="small">删除</el-button> -->
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column prop="freeze" label="禁用" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.freeze" active-color="#13ce66" inactive-color="#C9C9C9" @change="change(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <el-dialog v-if="dialogFormVisible" :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" label-width="120px" :rules="rules">
        <el-form-item label="用户账号" prop="userName">
          <el-input v-model="formData.userName" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="用户密码" prop="password">
          <el-input v-model="formData.password" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formData.mobile" style="width: 90%" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="账户角色">
          <el-select multiple v-model="formData.id" style="width: 90%" @input="testSX">
            <el-option v-for="(item,index) in roles" :key="index" :label="item.jurisdictionName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="closs()">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import permission from "../../directives/permission";

export default {
  name: "list",
  // directives: {
  //     permission
  // },
  data() {
    return {
      tableData: [],
      filters: {
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
        },
        jurisdictionId: ''
      },
      dialogFormVisible: false,
      formData: {},
      roles: [],
      rules: {
        userName: [{
          required: true,
          message: '请输入用户账号',
          trigger: 'blur'
        },],
        password: [{
          required: true,
          message: '请输入用户密码',
          trigger: 'blur'
        },],
        mobile: [{
          required: true,
          message: '请输入用户手机号',
          trigger: 'blur'
        },],
      },
      accountId: '',
      disabled: false,
    }
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.filters)
        }, {
            random: Math.random()
          })
      })
    },
    add() {
      this.dialogFormVisible = true
      this.formData = {}
      this.accountId = ''
      api.request("employee/findJurisdictionList", {}, (res) => {
        this.roles = res.data.list
      })
    },
    change(index, row) {
      console.log(row);
      let data = {
        empId: row.empId
        // 0：正常 1：禁用
      }
      api.request("/employee/updateEmployeeFreeze", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "状态修改成功")
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "状态修改失败")
          this.query(this.filters.pagination.page)
        }
      })
    },
    doAddgoods() {
      console.log(this.formData.password);
      let userId = Lockr.get("skinEmpId");
      if (!this.accountId) {
        let arr = []
        this.roles.forEach(ele => {
          this.formData.id.forEach(item => {
            if (ele.id == item) {
              arr.push(ele.jurisdictionName)
            }
          });
        });
        var querys = {
          mobile: this.formData.mobile,
          userId: userId,
          userName: this.formData.userName,
          password: md5(this.formData.password),
          jurisdictionId: this.formData.id.toString(),
          jurisdictionName: arr.toString(),
        }
        api.request("employee/createEmployee", querys, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "新增成功")
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", "新增失败")
            this.query(this.filters.pagination.page)
          }
        })
      } else {
        let arr = []
        this.roles.forEach(ele => {
          this.formData.id.forEach(item => {
            if (ele.id == item) {
              arr.push(ele.jurisdictionName)
            }
          });
        });
        var querys = {
          password: md5(this.formData.password),
          userName: this.formData.userName,
          mobile: this.formData.mobile,
          empId: this.formData.empId,
          jurisdictionId: this.formData.id.toString(),
          jurisdictionName: arr.toString(),
          userId: userId,
        }
        api.request("employee/updateEmployeeLogin", querys, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "修改成功")
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", "修改失败")
            this.query(this.filters.pagination.page)
          }
        })
      }

    },
    edit(index, row) {
      this.dialogFormVisible = true
      this.accountId = row.empId
      // console.log(row)
      this.formData = JSON.parse(JSON.stringify(row))
      this.formData.id = _g.turnNum(this.formData.jurisdictionId.split(','))
      // console.log(this.formData.id);
      if (this.formData.id == NaN || this.formData.id == '' || !this.formData.id) {
        this.formData.id = ''
      }
    },
    query(page) {
      var querys = {
        empno: this.filters.empno,
        name: this.filters.name,
        page: page,
        size: this.filters.pagination.limit,
        moblie: this.filters.mobile,
        jurisdictionId: this.filters.jurisdictionId.toString(),
      }
      api.request("employee/findEmployeePageList", querys, (res) => {
        this.tableData = res.data.list
        this.filters.pagination.total = res.data.total
      })
    },
    closs() {
      this.dialogFormVisible = false
    },
  },
  created() {
    this.query(this.filters.pagination.page)
    api.request("employee/findJurisdictionList", {}, (res) => {
      this.roles = res.data.list
    })
  },
  watch: {
    '$route'(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    }
  }
}
</script>

<style scoped>
</style>